// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2sfp0","colCheckbox":"styles_colCheckbox__Liv8S"};